import styled from "@emotion/styled";
import { Card, Col, Row, Tabs, Typography } from "antd";
import { goBack } from "assets/icons/index";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import RecipeInventoryPanel from "components/ManageProduct/Recipe/RecipeInventoryPanel";
import { MASTER_STOCK_LABEL } from "components/ManageProduct/Recipe/bundleLabels";
import MasterStockPanel from "./MasterStockPanel";

/** หน้า "คลังสินค้า" — รวมมาสเตอร์สต็อก + ชุดเซ็ต (ย้ายออกมาจากหน้าจัดการสินค้า) */
const Warehouse = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState<"master" | "bundle">("master");

  return (
    <Row className="rowgap-vbox" gutter={[24, 0]}>
      <Col span={24}>
        <Card bordered={false} className="criclebox h-full tabs-mobile">
          <HeaderTabs>
            <IconWrapper onClick={() => navigate("/setting")}>
              <SpanIcon>{goBack}</SpanIcon>
            </IconWrapper>
            <Typography.Title level={5}>คลังสินค้า</Typography.Title>
            <span style={{ width: 40 }} />
          </HeaderTabs>

          <Section>
            <Tabs
              activeKey={tab}
              onChange={(k) => setTab(k as "master" | "bundle")}
              items={[
                {
                  key: "master",
                  label: MASTER_STOCK_LABEL,
                  children: <MasterStockPanel />,
                },
                {
                  key: "bundle",
                  label: "bundle",
                  disabled: true,
                  children: <RecipeInventoryPanel />,
                },
              ]}
            />
          </Section>
        </Card>
      </Col>
    </Row>
  );
};

export default Warehouse;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Section = styled.div`
  padding: 12px 10px;
`;
